import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";

import FactSelector from "../../Component/FactSelector";
import SimpleEditObject from "../../Component/SimpleEditObject";
import SidebarObject from "../../Component/SidebarObject";

import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import AddColumnButton from "./AddColumnButton";

import { QuizObject } from "../../../../store/modquiz/quiz_objects/quiz-object";

import "./style.css";

interface SubjectSimpleEditComponentProps {
    addNewObject: Function;
    subject: any;
    isLoggedIn: boolean;
    allFacts: Array<string>;
    shownFacts: Array<string>;
    objectStore: any;
    toggleFact: Function;
    showFact: Function;
}

const SubjectSimpleEditComponent = observer(
    ({
        addNewObject,
        subject,
        allFacts,
        shownFacts,
        isLoggedIn,
        objectStore,
        toggleFact,
        showFact
    }: SubjectSimpleEditComponentProps) => {
        const [openHelp, setOpenHelp] = useState(false);

        let lastI = 0;

        let objectRows: any[] = [];

        let sorted_by_new = Array.from(subject.objects.values()).sort(
            (a: any, b: any) => {
                if (a.new == true && b.new == false) {
                    return -1;
                }
                if (a.new == false && b.new == true) {
                    return 1;
                }

                if (!a.title || !b.title) return 0;
                var titleA = a.title.toUpperCase(); // ignore upper and lowercase
                var titleB = b.title.toUpperCase(); // ignore upper and lowercase

                if (titleA < titleB) {
                    return -1;
                }

                if (titleA > titleB) {
                    return 1;
                }

                // names must be equal
                return 0;
            }
        );

        {
            sorted_by_new.forEach((object: any, i: number) => {
                objectRows.push(
                    <SimpleEditObject
                        createObject={objectStore.createFromQuizObject}
                        saveObject={objectStore.save}
                        quiz_object={object}
                        fields={shownFacts}
                        i={i}
                        editable={subject.canEdit}
                    />
                );
                lastI = i;
            });
        }

        const addRow = (e: any) => {
            addNewObject();
        };

        const addField = (fieldName: string) => {
            showFact(fieldName);
        };

        let headings = (
            <tr>
                {["Link", "Title", "Definition"].concat(shownFacts).map(field => {
                    if (field == "Link")
                        return <th style={{ textAlign: "center", width: "1px", whiteSpace: "nowrap"}}>{field}</th>;
                    return <th>{field}</th>;
                })}
            </tr>
        );

        return (
            <Grid container direction="row">
                <Grid item xs={"auto"} sm={3} md={2}>
                    <SidebarObject
                        subjectHashKey={subject.hash_key}
                        hasCreateAccess={isLoggedIn}
                        subject={subject}
                        subject_user={subject.user}
                        subject_slug={subject.slug}
                    />
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    <Paper square>
                        <div className="QuizObjectEditor">
                            <div className="row CardStats">
                                <div className="col-lg-7 offset-1">
                                    <ButtonGroup
                                        className="separated"
                                        variant="text"
                                    >
                                        <Button onClick={e => addRow(e)}>
                                            + Row
                                        </Button>
                                        <AddColumnButton addColumn={addField} />
                                    </ButtonGroup>
                                </div>
                                <div className="col-lg-2 pull-right">
                                    <ButtonGroup
                                        className="separated pull-right"
                                        variant="text"
                                    >
                                        <Button onClick={e => setOpenHelp(!openHelp)}>
                                            help
                                        </Button>

                                        <FactSelector
                                            allFacts={allFacts}
                                            selectedFacts={shownFacts}
                                            toggleFact={toggleFact}
                                        />
                                    </ButtonGroup>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-9 offset-1">
                                    {openHelp ? (
                                        <p>
                                            This is a list of all the cards in
                                            your deck. Changing the title or
                                            description here, will change the
                                            title and description for that card.
                                            You can also edit facts together on
                                            this page. The first two facts are
                                            listed, but if you want to edit a
                                            different fact, you can add a new
                                            one by clicking the "+ Fact Button"
                                            to the left, or, to show a column of
                                            a fact that already exists, use the
                                            "columns" button on the upper right.
                                            If you need to do advanced editing,
                                            you can do so by clicking on one of
                                            the cards in the left sidebar.
                                        </p>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-9 offset-1">
                                    {!subject.canEdit && (
                                        <p className="modquiz-editor-notice" role="status">
                                            Sign in as the subject owner to edit these cards.
                                        </p>
                                    )}
                                    <table className="table">
                                        <thead>{headings}</thead>
                                        <tbody>{objectRows}</tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
);

export default SubjectSimpleEditComponent;
